import { toast } from "sonner";

import { getApiErrorMessage, parseValidationErrors } from "@/lib/api";
import { CAMPOS_DE_USUARIO, type CampoDeUsuario } from "@/components/usuarios/UsuarioFormulario";

/**
 * Tratamiento del fallo de guardado de una ficha de usuario, compartido por el
 * alta y la edición: los errores de campo del 422 van PEGADOS a su campo (ahí
 * se corrigen) y cualquier otro fallo va a un toast, para no tragarse el
 * detalle.
 *
 * Cubre además los dos rechazos de auto-bloqueo del backend (`perfil_id` y
 * `acceso`), que llegan con la misma forma que una validación común.
 */
export function manejarErrorDeUsuario(
  error: unknown,
  errorDeCampo: (campo: CampoDeUsuario, mensaje: string) => void,
  fallback: string,
): void {
  const errores = parseValidationErrors(error);
  const conError = errores ? CAMPOS_DE_USUARIO.filter((campo) => errores[campo]) : [];

  if (conError.length > 0) {
    for (const campo of conError) {
      errorDeCampo(campo, errores![campo]!);
    }
    return;
  }

  toast.error(getApiErrorMessage(error, fallback));
}
